import { render, staticRenderFns } from "./ResetPasswordPanel.vue?vue&type=template&id=21d155d3&scoped=true&"
import script from "./ResetPasswordPanel.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPanel.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordPanel.vue?vue&type=style&index=0&id=21d155d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d155d3",
  null
  
)

export default component.exports